import baseLayer from '../components/layout/index.vue';
import pageLayer from '../components/layout/page.vue';

export const orgRoute = {
  path: '/org',
  component: baseLayer,
  meta: {
    elementId: '',
    level: 0
  },
  children: [
    {
      path: '/',
      redirect: 'index'
    },
    {
      path: 'index',
      name: 'org_home',
      component: pageLayer,
      meta: {
        elementId: 'org_home',
        level: 1
      },
      children: [
        {
          path: '/',
          name: 'org_index',
          meta: {
            elementId: 'org_index',
            level: 1
          },
          component: () => import('@/pages/organization/index')
        },
        {
          path: '/org/myService',
          name: 'org_myService',
          meta: {
            isSubPage: true,
            root: 'org_index'
          },
          component: () => import('@/pages/organization/myService/index')
        }
      ]
    },
    {
      path: 'customer',
      meta: {
        menuId: 2,
        level: 1
      },
      name: 'org_customer',
      component: pageLayer,
      children: [
        {
          path: 'all',
          name: 'org_customer_all',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/customer/all')
        },
        {
          path: 'common',
          name: 'org_customer_common',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/customer/common')
        },
        {
          path: 'record',
          name: 'org_customer_record',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/customer/followupRecord')
        },
        {
          path: 'expRecord',
          name: 'org_customer_expRecord',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/customer/expRecord')
        },
        {
          path: 'marketAnalysis/saleManagement',
          name: 'org_customer_marketAnalysis_saleManagement',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/saleManagement')
        },
        {
          path: 'marketAnalysis/customerRecord',
          name: 'org_customer_marketAnalysis_customerRecord',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/customerRecord')
        },
        {
          path: 'addCustomer',
          name: 'org_customerRecord_addCustomer',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_customerRecord',
            menuName: '客户数量统计'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/customerRecord/addCustomer')
        },
        {
          path: 'branchCount',
          name: 'org_customerRecord_branchCount',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_customerRecord',
            menuName: '校区客户数量对比'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/customerRecord/branchCount')
        },
        {
          path: 'customerCount',
          name: 'org_customerRecord_customerCount',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_customerRecord',
            menuName: '销售人员客户数量对比'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/customerRecord/customerCount')
        },
        {
          path: 'marketAnalysis/expTransformation',
          name: 'org_customer_marketAnalysis_expTransformation',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/expTransformation/index.vue')
        },
        {
          path: 'expRecord/:type',
          name: 'org_expTransformation_expRecord',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_expTransformation',
            menuName: '体验记录统计'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail')
        },
        {
          path: 'expTeacher/:type',
          name: 'org_expTransformation_expTeacher',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_expTransformation',
            menuName: '体验课任课老师统计'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail')
        },
        {
          path: 'expOrgUser/:type',
          name: 'org_expTransformation_expOrgUser',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_expTransformation',
            menuName: '体验课经办人统计'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail')
        },
        {
          path: 'expCourse/:type',
          name: 'org_expTransformation_expCourse',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_expTransformation',
            menuName: '体验课程统计'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail')
        },
        {
          path: 'marketAnalysis/signUpOrder',
          name: 'org_customer_marketAnalysis_signUpOrder',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/signUpOrder/index.vue')
        },
        {
          path: 'order/:type',
          name: 'org_signUpOrder_order',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_signUpOrder',
            menuName: '报名订单统计'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/signUpOrder/signUpDetail')
        },
        {
          path: 'sale/:type',
          name: 'org_signUpOrder_sale',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_signUpOrder',
            menuName: '销售人员成交单量统计'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/signUpOrder/signUpDetail')
        },
        {
          path: 'course/:type',
          name: 'org_signUpOrder_course',
          meta: {
            isSubPage: true,
            root: 'org_customer_marketAnalysis_signUpOrder',
            menuName: '课程报名量对比'
          },
          component: () =>
            import('@/pages/organization/customer/marketAnalysis/signUpOrder/signUpDetail')
        }
      ]
    },
    // 内部管理
    {
      path: 'hr',
      meta: {
        menuId: 2,
        level: 1
      },
      name: 'org_hr',
      component: pageLayer,
      children: [
        {
          path: 'user',
          name: 'org_hr_user',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/hr/user')
        },
        {
          path: 'authgroup',
          name: 'org_hr_authgroup',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/hr/authGroup')
        },
        {
          path: 'authgroup/add',
          name: 'org_hr_authgroup_add',
          meta: {
            menuId: 2,
            level: 3,
            isSubPage: true,
            menuName: '新增权限组',
            root: 'org_hr_authgroup'
          },
          component: () => import('@/pages/organization/hr/authGroup/edit')
        },
        {
          path: 'authgroup/edit',
          name: 'org_hr_authgroup_edit',
          meta: {
            menuId: 2,
            level: 3,
            isSubPage: true,
            menuName: '编辑权限组',
            root: 'org_hr_authgroup'
          },
          component: () => import('@/pages/organization/hr/authGroup/edit')
        },
        {
          path: 'order',
          name: 'org_hr_order',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/hr/order')
        },
        {
          path: 'withdraw',
          name: 'org_hr_withdraw',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/hr/withdraw')
        }
      ]
    },
    // 商品管理
    {
      name: 'org_goods',
      path: 'goods',
      meta: {
        menuId: 2,
        level: 1
      },
      component: pageLayer,
      children: [
        {
          path: 'commodity/goods',
          name: 'org_goods_commodity_goods',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/hr/commodity/goods')
        },
        {
          path: 'commodity/type',
          name: 'org_goods_commodity_type',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/hr/commodity/type')
        }]
    },
    // **营销中心 */
    {
      path: 'miniApp',
      meta: {
        menuId: 2,
        level: 1
      },
      name: 'org_miniapp',
      component: pageLayer,
      children: [
        {
          path: 'marketingData/coupon',
          name: 'org_miniApp_marketingData_coupon',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/marketingData/coupon')
        },
        {
          path: 'marketingData/orderManage',
          name: 'org_miniApp_marketingData_orderManage',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/marketingData/orderManage')
        },
        {
          path: 'marketingData/reservationList',
          name: 'org_miniApp_marketingData_reservationList',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/marketingData/reservationList')
        },
        {
          path: 'marketingData/recommendList',
          name: 'org_miniApp_marketingData_recommendList',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/marketingData/recommendList')
        },
        {
          path: 'dataAnalyse/basicData',
          name: 'org_miniApp_basicData',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/miniApp/analyse/base')
        },
        {
          path: 'dataAnalyse/reservation',
          name: 'org_miniApp_reservation',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/miniApp/analyse/reservation')
        },
        {
          path: 'dataAnalyse/activity',
          name: 'org_miniApp_activity',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/miniApp/analyse/activity')
        },
        {
          path: 'setting/course',
          name: 'org_miniApp_course',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/miniApp/setting/course')
        },
        {
          path: 'setting/banner',
          name: 'org_miniApp_banner',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/miniApp/setting/banner')
        },
        {
          path: 'setting/dynamic',
          name: 'org_miniApp_dynamic',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/dynamic')
        },
        {
          path: 'homeActivitySetting',
          name: 'org_miniApp_homeActivitySetting',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/homeActivitySetting')
        },
        {
          path: 'homeCouponSetting',
          name: 'org_miniApp_homeCouponSetting',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/homeCouponSetting')
        },
        {
          path: 'setting/dynamic/edit/:orgNewId',
          name: 'org_miniApp_dynamic_edit',
          meta: {
            isSubPage: true,
            root: 'org_miniApp_dynamic',
            menuName: '动态维护'
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/dynamic/edit')
        },
        {
          path: 'setting/student',
          name: 'org_miniApp_student',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/student')
        },
        {
          path: 'setting/coach',
          name: 'org_miniApp_coach',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/miniApp/setting/coach')
        },
        {
          path: 'setting/orgIntro',
          name: 'org_miniApp_orgIntro',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/orgIntro')
        },
        {
          path: 'setting/branchIntro',
          name: 'org_miniApp_branchIntro',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/branchIntro')
        },
        {
          path: 'setting/branchIntro/edit/:branchId',
          name: 'org_miniApp_branchIntro_edit',
          meta: {
            isSubPage: true,
            root: 'org_miniApp_branchIntro',
            menuName: '校区维护'
          },
          component: () =>
            import('@/pages/organization/miniApp/setting/branchIntro/edit')
        },
        {
          path: 'marketing/homepage/:type',
          name: 'org_miniApp_marketing_homepage',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/marketing/homepage')
        },
        {
          path: 'marketing/bargain',
          name: 'org_miniApp_marketing_bargain',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/miniApp/marketing/bargain')
        },
        {
          path: 'marketing/bargain/edit/:activityId',
          name: 'org_miniApp_marketing_bargain_edit',
          meta: {
            isSubPage: true,
            root: 'org_miniApp_marketing_bargain',
            menuName: '砍价活动'
          },
          component: () =>
            import('@/pages/organization/miniApp/marketing/bargain/edit')
        },
        {
          path: 'marketing/auditions',
          name: 'org_miniApp_marketing_auditions',
          meta: {
            isSubPage: true,
            root: 'org_miniApp_marketing_auditions'
          },
          component: () =>
            import('@/pages/organization/miniApp/marketing/auditions')
        },
        {
          path: 'marketing/auditions/:mode/:id',
          name: 'org_miniApp_marketing_auditionsmodel',
          meta: {
            isSubPage: true,
            root: 'org_miniApp_marketing_auditions',
            menuName: '体验课制作'
          },
          component: () =>
            import('@/pages/organization/miniApp/marketing/auditions/addModel')
        },
        {
          path: 'oldAndNew/setting',
          name: 'org_miniApp_oldAndNew_setting',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
          import('@/pages/organization/miniApp/oldAndNew/setting')
        },
        {
          path: 'oldAndNew/rewardRecord',
          name: 'org_miniApp_oldAndNew_rewardRecord',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
          import('@/pages/organization/miniApp/oldAndNew/rewardRecord')
        },
        {
          path: 'mall',
          name: 'org_miniApp_mall',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
          import('@/pages/organization/miniApp/mall')
        }
      ]
    },
    // ** 办理中心 */
    {
      name: 'org_handle',
      path: 'control',
      meta: {
        menuId: 2,
        level: 1
      },
      component: pageLayer,
      children: [
        {
          path: 'transferSchool', // 转校
          name: 'org_handle_transferSchool',
          meta: {
            menuId: 1,
            level: 2
          },
          component: () => import('@/pages/organization/handle/transferSchool')
        },
        {
          path: 'bunchclass', // 串课
          name: 'org_handle_bunchclass',
          meta: {
            menuId: 1,
            level: 2
          },
          component: () => import('@/pages/branch/handle/transferClass')
        },
        {
          path: 'classhourlist', // 课时列表
          name: 'org_control_classhourlist',
          meta: {
            menuId: 1,
            level: 2
          },
          component: () => import('@/pages/organization/handle/classHourList')
        }
      ]
    },
    // ** 保险 */
    {
      path: 'insurance',
      meta: {
        menuId: 2,
        level: 1
      },
      component: pageLayer,
      children: [
        {
          path: 'index',
          name: 'org_insurance_index',
          meta: {
            menuId: 2,
            level: 1
          },
          component: () => import('@/pages/organization/insurance/index')
        },
        {
          path: 'insurance',
          name: 'org_insurance_insurance',
          meta: {
            menuId: 2,
            level: 1
          },
          component: () => import('@/pages/organization/insurance/insurance')
        },
        {
          path: 'settings',
          name: 'org_insurance_settings',
          meta: {
            menuId: 2,
            level: 1
          },
          children: [
            {
              path: 'insuranceInfoSet',
              name: 'org_insurance_insuranceInfoSet',
              meta: {
                menuId: 3,
                level: 2,
                isSubPage: true,
                root: 'org_insurance_settings'
              },
              component: () =>
                import('@/pages/organization/insurance/insuranceInfoSet')
            }
          ],
          component: () => import('@/pages/organization/insurance/settings')
        },
        {
          path: 'log',
          name: 'org_insurance_log',
          meta: {
            menuId: 2,
            level: 1
          },
          component: () => import('@/pages/organization/insurance/log')
        },
        {
          path: 'insuranceStudents',
          name: 'org_insurance_insuranceStudents',
          meta: {
            menuId: 2,
            level: 1
          },
          component: () => import('@/pages/organization/insurance/insuranceStudents')
        },
        {
          path: 'renewal',
          name: 'org_insurance_renewal',
          meta: {
            menuId: 2,
            level: 1
          },
          component: () => import('@/pages/organization/insurance')
        }
      ]
    },
    // ** 教务中心 */
    {
      path: 'educational',
      meta: {
        menuId: 2,
        level: 1
      },
      name: 'org_educational',
      component: pageLayer,
      children: [
        {
          path: 'student',
          name: 'org_educational_student',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/educational/student')
        },
        {
          path: 'student/:StudentId',
          name: 'org_educational_student_archeives',
          meta: {
            isSubPage: true,
            root: 'org_educational_student',
            menuName: '学员档案'
          },
          component: () =>
            import('@/pages/organization/educational/student/archives')
        },
        {
          path: 'evaluatepackage',
          name: 'org_educational_evaluatepackage',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/branch/educational/evaluatePackage')
        }
      ]
    },
    // ** 基础设置 */
    {
      path: 'base',
      meta: {
        menuId: 2,
        level: 1
      },
      name: 'org_base',
      component: pageLayer,
      children: [
        {
          path: 'setting/orgInfo',
          name: 'org_base_setting_orgInfo',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/orgInfo')
        },
        {
          path: 'setting/account',
          name: 'org_base_setting_account',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/account')
        },
        {
          path: 'setting/customerSource',
          name: 'org_base_setting_customerSource',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/customerSetting/customerSource.vue')
        },
        {
          path: 'handle/payscene',
          name: 'org_base_handle_payscene',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/label/payscene')
        },
        {
          path: 'handle/print',
          name: 'org_base_handle_print',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/commonsetting/print')
        },
        {
          path: 'handle/ticket',
          name: 'org_base_handle_ticket',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/rideSetting')
        },
        {
          path: 'baseSetting/WXsetting',
          name: 'org_base_baseSetting_WXsetting',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/WXSetting')
        },
        {
          path: 'baseSetting/holiday',
          name: 'org_base_baseSetting_holiday',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/branch/educational/holiday')
        },
        {
          path: 'baseSetting/notice',
          name: 'org_base_baseSetting_notice',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () => import('@/pages/organization/baseSetting/commonsetting/notice')
        },
        {
          path: 'label',
          name: 'org_base_label',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/baseSetting/label/index.vue')
        },
        {
          path: 'label/student',
          name: 'org_base_label_student',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/baseSetting/label/student')
        },
        {
          path: 'label/coach',
          name: 'org_base_label_coach',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/baseSetting/label/coach')
        },
        {
          path: 'label/course',
          name: 'org_base_label_course',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/baseSetting/label/course')
        },
        {
          path: 'label/custom',
          name: 'org_base_label_custom',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/baseSetting/label/custom')
        },
        {
          path: 'label/class',
          name: 'org_base_label_class',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/baseSetting/label/class')
        },
        {
          path: 'label/studentTag',
          name: 'org_base_label_studentTag',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/baseSetting/label/studentTag')
        },
        {
          path: 'customerform',
          name: 'org_base_customerform',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/baseSetting/customerForm')
        },
        {
          path: 'commonsetting',
          name: 'org_base_commonsetting',
          meta: {
            menuId: 2,
            level: 2
          },
          children: [
            {
              path: 'classSet',
              name: 'org_base_commonsetting_classSet',
              meta: {
                isSubPage: true,
                root: 'org_base_commonsetting'
              },
              component: () =>
                import('@/pages/organization/baseSetting/commonsetting/classSet')
            },
            {
              path: 'studentsetting',
              name: 'org_base_commonsetting_studentsetting',
              meta: {
                isSubPage: true,
                root: 'org_base_commonsetting'
              },
              component: () =>
                import('@/pages/organization/baseSetting/commonsetting/studentsetting')
            },
            {
              path: 'register',
              name: 'org_base_commonsetting_register',
              meta: {
                isSubPage: true,
                root: 'org_base_commonsetting'
              },
              component: () =>
                import('@/pages/organization/baseSetting/commonsetting/register')
            },
            {
              path: 'commentSet',
              name: 'org_base_commonsetting_commentSet',
              meta: {
                isSubPage: true,
                root: 'org_base_commonsetting'
              },
              component: () =>
                import('@/pages/organization/baseSetting/commonsetting/commentSet')
            }
          ],
          component: () =>
            import('@/pages/organization/baseSetting/commonsetting')
        },
        {
          path: 'form',
          name: 'org_base_form',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/baseSetting/form/index.vue')
        },
        {
          path: 'studentform',
          name: 'org_base_studentform',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/baseSetting/studentform')
        },
        {
          path: 'branch',
          name: 'org_base_branch',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/baseSetting/branch')
        },
        {
          path: 'franchisee',
          name: 'org_base_franchisee',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/baseSetting/franchisee')
        },
        {
          path: 'branch/edit/:orgBranchId',
          name: 'org_base_branch_edit',
          meta: {
            isSubPage: true,
            root: 'org_base_branch',
            menuName: '校区维护'
          },
          component: () =>
            import('@/pages/organization/baseSetting/branch/edit')
        }
      ]
    },
    // ** 数据中心 */
    {
      path: 'dataAnalyse',
      meta: {
        menuId: 2,
        level: 1
      },
      name: 'org_dataAnalyse',
      component: pageLayer,
      children: [
        {
          path: 'fianacial',
          name: 'org_dataAnalyse_fianacial',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/dataCenter/financialData')
        },
        {
          path: 'schoolAllMoney',
          name: 'org_dataAnalyse_schoolAllMoney',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_schoolAllMoney'
          },
          component: () =>
            import('@/pages/organization/dataCenter/financialData/schoolAllMoney')
        },
        {
          path: 'schoolHasMoney',
          name: 'org_dataAnalyse_schoolHasMoney',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_schoolHasMoney'
          },
          component: () =>
            import('@/pages/organization/dataCenter/financialData/schoolHasMoney')
        },
        {
          path: 'courseEndMoney',
          name: 'org_dataAnalyse_courseEndMoney',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_courseEndMoney'
          },
          component: () =>
            import('@/pages/organization/dataCenter/financialData/courseEndMoney')
        },
        {
          path: 'lastMoney',
          name: 'org_dataAnalyse_lastMoney',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_lastMoney'
          },
          component: () =>
            import('@/pages/organization/dataCenter/financialData/lastMoney')
        },
        {
          path: 'educational',
          name: 'org_dataAnalyse_educational',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/dataCenter/educationalData')
        },
        {
          path: 'teachClass',
          name: 'org_dataAnalyse_teachClass',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_educational',
            menuName: '授课课时详情'
          },
          component: () =>
            import('@/pages/organization/dataCenter/educationalData/teachClass')
        },
        {
          path: 'studentAttend',
          name: 'org_dataAnalyse_studentAttend',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_educational',
            menuName: '学员出勤详情'
          },
          component: () =>
            import('@/pages/organization/dataCenter/educationalData/studentAttend')
        },
        {
          path: 'teacherRate',
          name: 'org_dataAnalyse_teacherRate',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_educational',
            menuName: '老师评分详情'
          },
          component: () =>
            import('@/pages/organization/dataCenter/educationalData/teacherRate')
        },
        {
          path: 'teacherAttend',
          name: 'org_dataAnalyse_teacherAttend',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_educational',
            menuName: '老师出勤详情'
          },
          component: () =>
            import('@/pages/organization/dataCenter/educationalData/teacherAttend')
        },
        {
          path: 'sale',
          name: 'org_dataAnalyse_sale',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () => import('@/pages/organization/dataCenter/saleData')
        },
        {
          path: 'saleFunnel',
          name: 'org_dataAnalyse_saleFunnel',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_sale',
            menuName: '销售漏斗详情'
          },
          component: () =>
            import('@/pages/organization/dataCenter/saleData/saleFunnel')
        },
        {
          path: 'saleData',
          name: 'org_dataAnalyse_saleData',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_sale',
            menuName: '销售数据详情'
          },
          component: () =>
            import('@/pages/organization/dataCenter/saleData/saleData')
        },
        {
          path: 'customer',
          name: 'org_dataAnalyse_customer',
          meta: {
            isSubPage: true,
            root: 'org_dataAnalyse_sale',
            menuName: '客户占比详情'
          },
          component: () =>
            import('@/pages/organization/dataCenter/saleData/customer')
        }
      ]
    },
    // 仓库
    {
      path: 'repertory',
      meta: {
        menuId: 2,
        level: 1
      },
      name: 'org_repertory',
      component: pageLayer,
      children: [
        {
          path: 'intimeStock',
          name: 'org_repertory_intimeStock',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/goods/repertory/intimeStock.vue')
        },
        {
          path: 'orgpurchase',
          name: 'org_repertory_orgpurchase',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/goods/repertory/orgPurchase')
        },
        {
          path: 'branchpurchase',
          name: 'org_repertory_branchpurchase',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/goods/repertory/branchPurchase')
        },
        {
          path: 'reportloss',
          name: 'org_repertory_reportloss',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/goods/repertory/loss')
        },
        {
          path: 'adjustment',
          name: 'org_repertory_adjustment',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/goods/repertory/adjustment')
        },
        {
          path: 'branchtransfer',
          name: 'org_repertory_branchtransfer',
          meta: {
            menuId: 2,
            level: 3
          },
          component: () =>
            import('@/pages/organization/goods/repertory/transfer')
        },
        {
          path: 'inoutlog',
          name: 'org_repertory_inoutlog',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/goods/repertory/inoutLog.vue')
        },
        {
          path: 'stockAlteration',
          name: 'org_repertory_stockAlteration',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/goods/repertory/stockAlteration.vue')
        },
        {
          path: 'setting',
          name: 'org_repertory_setting',
          meta: {
            menuId: 2,
            level: 2
          },
          component: () =>
            import('@/pages/organization/goods/repertory/setting.vue')
        },
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/orgRoute.js